import { render, staticRenderFns } from "./OptimizationCreate.vue?vue&type=template&id=f2ed7e7c&scoped=true"
import script from "./OptimizationCreate.vue?vue&type=script&lang=js"
export * from "./OptimizationCreate.vue?vue&type=script&lang=js"
import style0 from "./OptimizationCreate.vue?vue&type=style&index=0&id=f2ed7e7c&prod&lang=scss&scoped=true"
import style1 from "./OptimizationCreate.vue?vue&type=style&index=1&id=f2ed7e7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ed7e7c",
  null
  
)

export default component.exports